import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { ChangeLangHandlerService } from '@core/services/i18n/change-lang-handler.service';

import { mapKioskLanguageFlags } from './kiosk-language-flags.util';

@Component({
  selector: 'app-kiosk-select-language-block',
  templateUrl: './kiosk-select-language-block.component.html',
  providers: [ChangeLangHandlerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KioskSelectLanguageBlockComponent {
  private readonly changeLangService = inject(ChangeLangHandlerService);
  private readonly marketplaceStoreSelector = inject(MarketplaceStoreSelector);

  protected readonly languages = computed(() =>
    mapKioskLanguageFlags(this.marketplaceStoreSelector.selectMarketplace().locales),
  );

  onChangeLanguage(selectedLanguage: string, event: Event): void {
    event.stopPropagation();
    this.changeLangService.changeLang$.next(selectedLanguage);
  }
}
